import {useEffect, useState} from 'react';
import {InputType} from '../../configuration/inputTypes/inputTypes.config';
import {textInputValidation} from '../../services/TextInputValidation.service';
import {_SYSTEM_TITLES} from '../../configuration/SystemTitles/SystemTitles.config';

const useInput = (getValue, input_type, onBlurFunc, globalError, initValue, clearValue, onEnterFunc, getError) => {
    const [value, setValue] = useState('');
    const [error, setError] = useState('');


    /**
     * validateInput - validate inputs by input type
     * @param input_value - the input value
     */
    const validateInput = (input_value) => {

        switch (input_type) {
            case InputType.ProjectName:
                input_value = input_value.replace(/\s+/g, '_');
                if (input_value.length > 256) {
                    setError(_SYSTEM_TITLES.invalidProjectNameInputError);
                } else if (!input_value) {
                    setError(_SYSTEM_TITLES.missingProjectNameInputError);
                } else if ((!textInputValidation.runValidation(input_value, {key: 'PROJECT_AUTO_NAME_REGEX'}, false)) && !(input_value[input_value.length - 1] === ' ')) {
                    setError(_SYSTEM_TITLES.invalidProjectNameInputError);
                } else {
                    setError('');
                }
                setValue(input_value);
                break;
            case InputType.ClassName:
                input_value = input_value.replace(/\s+/g, '_');
                if (input_value.length > 256) {
                    setError(_SYSTEM_TITLES.invalidClassNameInputError);
                } else if (!input_value) {
                    setError(_SYSTEM_TITLES.missingClassNameInputError);
                } else {
                    setError('');
                }
                setValue(input_value);
                break;
            case InputType.ProjectDescription:
                setValue(input_value);
                break;
            case InputType.FeatureName:
                input_value = input_value.replace(/\s+/g, '_');
                if (!input_value) {
                    setError(_SYSTEM_TITLES.missingAiAnalysisNameInputError);
                } else {
                    setError('');
                }
                setValue(input_value);
                break;
            default:
                return;
        }

    };
    const onBlur = (e) => {
        input_type !== InputType.ProjectName && setError('');
        onBlurFunc && onBlurFunc(e);
    };

    /**
     * onEnter - when user press Enter
     * @param e - key event
     */
    const onEnter = (e) => {
        if (e.key === 'Enter') {
            input_type !== InputType.ProjectName && setError('');
            onEnterFunc && onEnterFunc(e);
        }
    };

    useEffect(() => {
        getError && getError(error);
    }, [error]);

    useEffect(() => {
        getValue && getValue(value);
    }, [value]);

    useEffect(() => {
        initValue && setValue(initValue);
    }, [initValue]);

    useEffect(() => {
        globalError && setError(globalError);
    }, [globalError]);


    useEffect(() => {
        clearValue && setValue('');
    }, [clearValue]);

    return {
        validateInput,
        value,
        setValue,
        error,
        onBlur,
        setError,
        onEnter
    };
};

export default useInput;
